

















import Vue from 'vue'
import DataItem from '@/components/DataItem.vue'
import moment from 'moment'

// In data() all relevant data objects are stored which are used to compare in the DataItem wrapper.

export default Vue.extend({
  name: 'Timetable',
  data() {
    return {
      currentItem: {},
      todayDateKey: moment().format('YYYYMMDD'),
      todayDate: moment().format('DD-MM-YYYY'),
      tomorrowDate: moment().add(1, 'days').format('DD-MM-YYYY')
    }
  },
  components: {
    DataItem
  },
  props: ['events', 'time'],
  mounted() {
    this.checkCurrentItem();
  },
  beforeUpdate() {
    this.checkCurrentItem();
  },
  methods: {

    checkCurrentItem() {
      let events = this.events;
      for (let index = 0; index < events.length; index++) {
        const element = events[index];
        for (let indexEvent = 0; indexEvent < element.posts.length; indexEvent++) {
          const event = element.posts[indexEvent];
          if(event.id === parseInt(this.$route.params.id)){
            this.currentItem = event;
          }
        }
      }
    },
  },
});
